import { useEffect, RefObject } from 'react';

type RefElement = RefObject<HTMLElement | null>;

interface RefStore {
    [key: string]: RefElement[];
}

const store: RefStore = {};

const handleResize = (key: string) => {
    const elements = store[key];
    if (elements) {
        let maxHeight = 0;
        elements.forEach((element) => {
            if (element.current && element.current.clientHeight > maxHeight) {
                maxHeight = element.current.clientHeight;
            }
        });
        elements.forEach((element) => {
            if (element.current) {
                element.current.style.minHeight = `${maxHeight}px`;
            }
        });
    }
};

const add = (key: string, element: RefElement) => {
    if (!store[key]) {
        store[key] = [];
    }
    store[key].push(element);
    return () => {
        const index = store[key].indexOf(element);
        if (index > -1) {
            store[key].splice(index, 1);
        }
    };
};

export const useSyncRefHeight = (
    refs: [string, RefElement][],
    deps: Array<any> = []
) => {
    useEffect(() => {
        const cleanups: (() => void)[] = [];
        refs.forEach(([key, element]) => {
            cleanups.push(add(key, element));
        });
        return () => {
            cleanups.forEach((cleanup) => cleanup());
        };
    }, []);
    useEffect(() => {
        refs.forEach(([key]) => {
            handleResize(key);
        });
    }, deps);
};
